import { ProfileDetailsPage } from './ProfileDetailsPage'

export const HelperProfilePanel = () => (
  <section className="flex-1 flex flex-col gap-4 min-h-0" data-testid="helper-profile-panel">
    <ProfileDetailsPage variant="helper" />
  </section>
)
